import { Observable } from 'rxjs';
import { ofType, StateObservable } from 'redux-observable';
import { withLatestFrom, concatMap } from 'rxjs/operators';
import { Action } from 'redux';
import { CreateTrack } from '../action-creators';
import AppState from '../../state';
import { CreateReleaseSuccess } from '../../release/action-creators';
import { CREATE_RELEASE_SUCCESS } from '../../release/actions';

/**
 *
 * This effect creates a Track after a successful Release Creation
 *
 */

export const createTracksAfterReleaseEpic = (action$: Observable<Action>, state$: StateObservable<AppState>) =>
  action$.pipe(
    ofType<Action, CreateReleaseSuccess>(CREATE_RELEASE_SUCCESS),
    withLatestFrom(state$),
    concatMap(([action, state]) => {

      const tracks = Object.values(state.tracks.tracks).filter((t) => !t.releaseId);

      return tracks.map((track) => new CreateTrack(track.id as string, action.release.id as string));
    })
  );